// Base map layers and sources configuration
export const createBaseMapSources = () => {
  return {
    osm: {
      type: "raster",
      tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
      tileSize: 256,
      attribution: "© OpenStreetMap contributors"
    },
    satellite: {
      type: "raster",
      tiles: ["https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"],
      tileSize: 256,
      attribution: "© Esri"
    }
  };
};

export const createBaseMapLayers = () => {
  return [
    {
      id: "osm-base",
      type: "raster",
      source: "osm",
      minzoom: 0,
      maxzoom: 19,
      layout: { visibility: "visible" }
    },
    {
      id: "satellite",
      type: "raster",
      source: "satellite",
      minzoom: 0,
      maxzoom: 19,
      layout: { visibility: "none" }
    }
  ];
};

export const createBaseMapLayerTree = () => {
  return {
    "base-maps": {
      label: "Base Maps",
      layers: ["osm-base", "satellite"],
      children: {
        "osm-base": { label: "OSM Base", layers: ["osm-base"] },
        "satellite": { label: "Satellite", layers: ["satellite"] }
      }
    }
  };
};

export const createBaseMapLayerVisibility = () => {
  return {
    "osm-base": true,
    "satellite": false
  };
}; 